import { render, staticRenderFns } from "./SelectChat.vue?vue&type=template&id=7fa717f0&scoped=true&lang=pug&"
import script from "./SelectChat.vue?vue&type=script&lang=js&"
export * from "./SelectChat.vue?vue&type=script&lang=js&"
import style0 from "./SelectChat.vue?vue&type=style&index=0&id=7fa717f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa717f0",
  null
  
)

export default component.exports